import React, { useRef, useState } from 'react';
import { useUploadAvatarMutation } from '../../api/apiSlice';
import { Camera, UserCircle2 } from 'lucide-react';
import { useSelector } from 'react-redux';
import Loading from '../common/Loading';

const AvatarUpload = () => {
  const { user } = useSelector((state) => state.auth);
  const [uploadAvatar, { isLoading }] = useUploadAvatarMutation();
  const fileInputRef = useRef(null);
  const [error, setError] = useState('');
  const [progress, setProgress] = useState(0);

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    event.target.value = '';
    if (!file) return;

    setError('');
    setProgress(0);

    try {
      await uploadAvatar({ avatarFile: file, onProgress: setProgress }).unwrap();
      setProgress(100);
      setTimeout(() => setProgress(0), 600);
    } catch (err) {
      setError(err.data?.message || 'Ошибка.');
      setProgress(0);
    }
  };

  return (
    <div className="w-full text-center">
      <div 
        className="relative group w-32 h-32 mx-auto cursor-pointer"
        onClick={() => fileInputRef.current.click()}
      >
        {user?.avatarUrl ? (
          <img 
            src={user.avatarUrl} 
            alt="Аватар" 
            className="w-32 h-32 rounded-full object-cover shadow-md"
          />
        ) : (
          <div className="w-32 h-32 rounded-full bg-slate-200 dark:bg-slate-700 flex items-center justify-center shadow-md">
            <UserCircle2 className="text-slate-500 dark:text-slate-300 w-20 h-20" />
          </div>
        )}
        <div className={`absolute inset-0 rounded-full bg-black/60 flex flex-col items-center justify-center transition-opacity ${isLoading ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'}`}>
          {isLoading ? (
            <>
              <Loading variant="button" size="md" className="text-white" />
              {progress > 0 && progress < 100 && (
                <span className="text-white text-xs mt-1">{progress}%</span>
              )}
            </>
          ) : (
            <Camera className="text-white" />
          )}
        </div>
      </div>
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        className="hidden"
        accept="image/png, image/jpeg"
      />
      <button 
        onClick={() => fileInputRef.current.click()}
        className="mt-4 text-sm text-blue-600 hover:underline dark:text-blue-400"
      >
        Измениить аватар
      </button>
      {error && <p className="text-red-500 text-xs mt-2">{error}</p>}
    </div>
  );
};

export default AvatarUpload;
